import { Component, ElementRef } from '@angular/core';
import {StableLinkIntegrationService} from './core/services/stable-link-integration.service';
import { Timestamp } from "../timestamp/Timestamp";
import { NotificationService, Notification } from './core/services/notification.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    template: '<qrcode #qrcode [value]="angularLink"></qrcode><button (click)="downloadQRCode()">Download</button>',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent {

  public isValid_val: string = '';
  public preferred_Username!: string;
  username = '';
  menuOpen = false;

  // Notification modal properties
  showNotificationModal = false;
  unreadNotifications: Notification[] = [];

  constructor(
    private configService: StableLinkIntegrationService,
    private notificationService: NotificationService,
    private oauthService: OAuthService,
    private router: Router,
    private elRef: ElementRef,
    // private clipboardService: ClipboardService,
  ) {
    console.log("compiled version timestamp:", Timestamp.stamp);
  }

  ngOnInit() {
    this.configService.login();
    this.updateUsername();
    
    // Handle Graph API token callback from iframe (for email validation)
    this.handleGraphTokenCallback();
    
    // Check for unread notifications and show modal if any exist
    this.checkForNotifications();
  }

  /**
   * Handle Graph API token callback from Azure AD redirect
   * When popup/iframe requests a Graph token, Azure AD redirects back to this app with token in URL hash
   * This code extracts the token and posts it back to the opener/parent window
   */
  private handleGraphTokenCallback(): void {
    if (!environment.production) {
      console.log('🔍 Checking for Graph token callback...');
      console.log('Window parent match:', window === window.parent);
      console.log('Window opener:', window.opener ? 'EXISTS' : 'NULL');
      // Note: do NOT log window.location.hash — it may contain access_token
    }

    // Check if we're in a popup (opener) or iframe (parent) AND have OAuth response in URL
    if ((window.opener || window !== window.parent) && window.location.hash) {
      if (!environment.production) { console.log('✅ Detected callback context with hash!'); }
      try {
        const params = new URLSearchParams(window.location.hash.substring(1));
        const token = params.get('access_token');
        const error = params.get('error');
        const errorDescription = params.get('error_description');

        if (!environment.production) {
          console.log('Token found:', token ? 'YES' : 'NO');
          console.log('Error found:', error ? error : 'NO');
        }

        // Determine target window (popup uses opener, iframe uses parent)
        const target = window.opener || window.parent;

        if (token) {
          if (!environment.production) { console.log('🔐 Received Graph token, posting to opener/parent...'); }
          // Post token to opener/parent window (the email validation service)
          target.postMessage(
            { type: 'graph-token', token },
            window.location.origin
          );
          if (!environment.production) { console.log('✅ Token posted successfully'); }
        } else if (error) {
          console.error('❌ Azure AD error:', error, errorDescription);
          // Post error to opener/parent window
          target.postMessage(
            { type: 'graph-token', error: `${error}: ${errorDescription}` },
            window.location.origin
          );
          if (!environment.production) { console.log('✅ Error posted to opener/parent'); }
        }
      } catch (error) {
        console.error('Error handling Graph token callback:', error);
      }
    } else {
      if (!environment.production) { console.log('ℹ️ Not an iframe callback (window === parent or no hash)'); }
    }
  }

  private read(key: string): any {
    const data = localStorage.getItem(key);
    if (data != null) {
      return JSON.parse(data);
    }

    return;
  }

  private write(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * Check for unread notifications and show modal if any exist
   */
  private checkForNotifications(): void {
    this.notificationService.getUnreadNotifications().subscribe(notifications => {
      if (notifications.length > 0) {
        this.unreadNotifications = notifications;
        this.showNotificationModal = true;
      }
    });
  }

  private updateUsername(): void {
    const claims = this.oauthService.getIdentityClaims();
    if (claims && claims['preferred_username']) {
      this.username = claims['preferred_username'];
    }
    // Also subscribe to token events so username populates after OAuth completes
    this.oauthService.events.subscribe(event => {
      if (event.type === 'token_received' || event.type === 'token_refreshed') {
        const c = this.oauthService.getIdentityClaims();
        if (c && c['preferred_username']) {
          this.username = c['preferred_username'];
        }
      }
    });
  }

  /**
   * Handle notification modal close event
   */
  onNotificationModalClose(): void {
    // Mark all displayed notifications as read
    const notificationIds = this.unreadNotifications.map(n => n.id);
    this.notificationService.markMultipleAsRead(notificationIds);
    
    // Close the modal
    this.showNotificationModal = false;
    this.unreadNotifications = [];
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  onDocumentClick(event: MouseEvent): void {
    if (!this.elRef.nativeElement.querySelector('.user-menu-wrapper')?.contains(event.target)) {
      this.menuOpen = false;
    }
  }

  goToProfile(): void {
    this.menuOpen = false;
    this.router.navigate(['/profile']);
  }

}
